export default {"src":"/_next/static/media/Gastrointestinaldisorders.030838af.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};